module.exports = __webpack_public_path__ + "img/cooperation12.412e943e.png";